export const STR = {
  en: {
    nav_home: "Home", nav_about: "About", nav_treatments: "Treatments", nav_guides: "Guides",
    nav_contact: "Contact", nav_book: "Book Appointment",
    brand_tag: "Orthopedic Simple & Complex Trauma and Reconstruction",
    footer_blurb: "Orthopaedic Simple & Complex Trauma and Reconstruction Surgery Specialist — restoring movement and rebuilding lives through precise, evidence-based fracture and joint care in Mumbai.",
    footer_explore: "Explore", footer_reach: "Reach the Clinic",
    footer_rights: "© 2026 Dr. Lokesh Naik G — Orthopaedic Trauma Care. All rights reserved.",
    footer_opd: "OPD: Mon–Fri 11 AM – 7 PM · Sat 11 AM – 3 PM · Sunday Closed",
    fl_home: "Home", fl_about: "About the Doctor", fl_treatments: "Treatments & Expertise",
    fl_guides: "Patient Guides", fl_book: "Book an Appointment", fl_contact: "Contact",

    hero_eyebrow: "Orthopaedic Simple & Complex Trauma Surgery · Mumbai",
    hero_line1: "Orthopaedic Trauma &", hero_line2: "Joint Replacement Consultant",
    hero_motto: "\"Life is Movement and Movement is Life\"",
    hero_tagline: "Restoring Movement and Rebuilding Lives…!",
    hero_sub: "{name} — {role} at {hospital}. Specialising in complex fractures, pelvic & acetabular trauma, and getting you back on your feet.",
    hero_call: "Call {phone}",
    stat_exp_label: "Surgical Experience",
    strip_from: "From the Surgical Suite",
    strip_note: "Real cases treated by Dr. Lokesh Naik G — patient details anonymised",

    phil_eyebrow: "The Practice Philosophy",
    phil_title1: "Trauma is chaos.", phil_title2: "Recovery is craft.",
    phil1_t: "Precision in chaos",
    phil1_b: "A fracture is never just a broken bone — it is an interrupted life. Every fixation is planned to restore anatomy, not approximate it.",
    phil2_t: "Evidence before opinion",
    phil2_b: "From the AO INFINITY study to editorial boards of international journals, the practice is anchored in research — so your treatment follows proof, not habit.",
    phil3_t: "Back on your feet",
    phil3_b: "Surgery is only the halfway mark. Rehabilitation is woven into every plan, because the real outcome is you — walking, working, living again.",

    exp_eyebrow: "Areas of Expertise",
    exp_title1: "Complex trauma,", exp_title2: "handled with calm.",
    exp_view_all: "View all treatments",

    about_eyebrow: "Meet Your Surgeon",
    about_para: "Trained at KIMS Hubli and Dr. Balabhai Nanavati Hospital, with fellowships in trauma and arthroplasty from Mumbai and Seoul — Dr. Naik has devoted his career to the hardest injuries in orthopaedics: complex fractures, pelvic trauma, nonunions and post-traumatic deformities.",
    about_badge1: "AO INFINITY Study Co-Investigator",
    about_badge2: "Journal Editor & Reviewer",
    about_badge3: "Trauma & Joint Replacement",
    about_link: "Read the full story",

    hosp_eyebrow: "Where to Find Us",
    hosp_para: "One of India's most advanced quaternary care centres — with dedicated trauma teams, state-of-the-art operating theatres and round-the-clock emergency support. Dr. Naik leads trauma and complex fracture services here.",
    hosp_cta: "Plan your visit",

    stories_eyebrow: "Patient Experiences",
    stories_verified: "{count} verified Google reviews",
    overlay_quote: "\"Back to life.\"", overlay_sub: "The only outcome that matters",
    wall_title1: "Every recovery has", wall_title2: "a voice.",
    wall_link: "Read all {count} reviews on Google",
    google_tag: "Google",

    cta_eyebrow: "Begin Your Recovery",
    cta_title1: "Your recovery begins with", cta_title2: "one conversation.",

    mq1: "Precision", mq2: "Restoration", mq3: "Mobility", mq4: "Trust",
    mq5: "Evidence-Based Care", mq6: "Recovery",

    ab_hero_eyebrow: "About the Doctor",
    ab_hero_l1: "A career built on", ab_hero_l2: "the hardest fractures.",
    ab_hero_sub: "From the classrooms of Davanagere to the operating theatres of Mumbai and the fellowship halls of Seoul — a journey of excellence devoted to a single promise: restoring movement, and with it, the lives it carries.",
    ab_qual_eyebrow: "Qualifications",
    ab_qual_title1: "Trained across", ab_qual_title2: "India & South Korea.",
    ab_bio1: "Lokesh Naik G began his medical training at JJMMC, Davanagere, where a fascination with the mechanics of the human body first took root. He built his surgical foundation at KIMS, Hubli, and went on to earn his D.N.B. in Orthopaedic Surgery at the renowned Dr. Balabhai Nanavati Hospital, Mumbai — one of the country's most demanding training grounds.",
    ab_bio2: "Driven to master the injuries other surgeons hesitate to touch, he pursued advanced fellowships in Trauma and Arthroplasty in Mumbai, then travelled to Seoul, South Korea — a global capital of joint replacement — to complete his fellowship in Revision Arthroplasty: the delicate discipline of giving failed surgeries a second life.",
    ab_bio3: "Today, every consultation carries the weight of that journey — world-class training delivered with a warmth that puts even the most anxious patient at ease. Beyond the operating theatre, he has published peer-reviewed research in national and international journals and authored book chapters, bringing academic rigour directly to the bedside.",
    ab_journey_eyebrow: "The Journey", ab_journey_title: "A journey of excellence.",
    ab_research_eyebrow: "Research & Academia",
    ab_research_title1: "The surgeon who", ab_research_title2: "also writes the science.",
    ab_infinity_label: "Landmark Research",
    ab_infinity_title: "The 'INFINITY' Study — AO Foundation, Davos",
    ab_infinity_body: "Dr. Naik served as Co-Investigator (2013–2015) in the world's largest multicentre study on infection in fracture fixation — research that shapes how surgeons worldwide prevent and treat one of trauma surgery's gravest complications.",
    ab_editorial_label: "Editorial & Review Roles",
    ab_cta_title1: "Experience that shows", ab_cta_title2: "in every outcome.",
    cta_book_btn: "Book a Consultation",

    tl1_p: "Foundation", tl2_p: "5 Years", tl3_p: "Residency", tl4_p: "2 Years",
    tl5_p: "2013 — 2015", tl6_p: "Fellowships", tl7_p: "2016 – Present",
    tl1_r: "M.B.B.S., then Diploma in Orthopaedics",
    tl2_r: "Lecturer / Consultant in Orthopaedic Surgery",
    tl3_r: "D.N.B. (Orthopaedic Surgery)",
    tl4_r: "Clinical Associate, Orthopaedics",
    tl5_r: "Co-Investigator, 'INFINITY' Study",
    tl6_r: "Trauma & Primary Arthroplasty (Mumbai), Revision Arthroplasty (Seoul)",
    tl7_r: "Senior Orthopaedic Trauma, Reconstruction & Joint Replacement Consultant",

    tr_hero_eyebrow: "Treatments & Expertise",
    tr_hero_l1: "Eight battlegrounds.", tr_hero_l2: "One standard: precision.",
    tr_hero_sub: "Orthopaedic trauma is unforgiving — the first intervention often decides the rest of a patient's life. These are the conditions Dr. Naik treats every day at Sir H. N. Reliance Foundation Hospital, Mumbai.",
    tr_guide_link: "Read the patient guide",
    tr_proc_eyebrow: "Procedures Performed",
    tr_proc_title1: "Surgical skill,", tr_proc_title2: "start to finish.",
    tr_proc_quote: "\"Restoration is an art practised with science.\"",
    tr_cta_title1: "Not sure which treatment", tr_cta_title2: "fits your condition?",
    tr_cta_sub: "Bring your reports and X-rays. A single consultation is often enough to chart the way forward.",
    tr_cta_btn: "Book a Consultation",

    pr1: "Open Reduction & Internal Fixation (ORIF)",
    pr2: "Total Hip Replacement",
    pr3: "Total Knee Replacement",
    pr4: "Revision & Redo Orthopaedic Surgeries",
    pr5: "Limb Lengthening & Deformity Correction",
    pr6: "Ankle Fusion Surgery",
    pr7: "Bow Legs Correction",
    pr8: "Fracture Fixation — Simple to Complex",

    bk_hero_eyebrow: "Book an Appointment",
    bk_hero_l1: "Let's plan your", bk_hero_l2: "recovery, together.",
    bk_hero_sub: "Share a few details and the clinic will confirm your consultation with {name}. For urgent trauma, please call directly.",
    bk_info_eyebrow: "Prefer to Talk?",
    bk_call_label: "Call / WhatsApp", bk_email_label: "Email", bk_clinic_label: "Clinic",
    bk_opd_label: "OPD Timings", bk_opd1: "Mon – Fri: 11 AM – 7 PM", bk_opd2: "Sat: 11 AM – 3 PM · Sun: Closed",
    bk_em_label: "Trauma Emergency?",
    bk_em_body: "Do not wait for an online confirmation. Call {phone} immediately or proceed to the emergency department.",
    f_name: "Full Name *", f_age: "Age *", f_sex: "Sex *", f_phone: "Phone *", f_email: "Email *",
    f_date: "Preferred Date *", f_time: "Preferred Time *", f_concern: "Concern *", f_message: "Tell Us More (optional)",
    f_name_ph: "Your full name", f_age_ph: "Years", f_phone_ph: "+91 ...", f_email_ph: "you@example.com",
    f_time_ph: "Choose a time slot", f_concern_ph: "What brings you in?", f_sex_ph: "Select",
    f_message_ph: "Briefly describe your injury or condition, and mention any reports or X-rays you have.",
    f_submit: "Request Appointment", f_submitting: "Sending request…",
    f_note: "Your request is emailed directly to the doctor's office at {email}. No payment is taken online.",
    f_validation: "Please choose the patient's sex, a concern and a preferred time slot.",
    sex_m: "Male", sex_f: "Female", sex_o: "Other",
    c1: "Fracture / Trauma", c2: "Joint Replacement", c3: "Nonunion / Malunion",
    c4: "Bone or Joint Infection", c5: "Deformity Correction", c6: "Second Opinion", c7: "Other",
    ts1: "Morning (10 AM – 1 PM)", ts2: "Afternoon (2 PM – 5 PM)", ts3: "Evening (5 PM – 8 PM)",
    ok_title: "Request received.",
    ok_body: "Thank you, {name}. Your appointment request for {date} ({slot}) has been sent to the clinic. The clinic will call you on {phone} to confirm.",
    ok_ref: "Reference:", ok_another: "Book another appointment",
    ok_email_note: " and emailed to the doctor's office.",
    toast_success: "Appointment request sent. The clinic will confirm shortly.",
    toast_error: "Could not submit right now — please call the clinic directly.",

    ct_hero_eyebrow: "Contact",
    ct_hero_l1: "One call can change", ct_hero_l2: "the way you walk.",
    ct_hero_sub: "Whether it's a fresh injury, a fracture that won't heal, or a second opinion — reach out. Every enquiry is answered personally by the clinic.",
    ct_call_label: "Call or WhatsApp",
    ct_call_body: "Fastest way to reach the clinic — for appointments and urgent trauma enquiries.",
    ct_call_now: "Call now",
    ct_email_label: "Write to Us",
    ct_email_body: "Share reports, X-rays or questions. Booking requests sent online also arrive here.",
    ct_email_cta: "Send an email",
    ct_visit_label: "Visit the Clinic", ct_hours_label: "Consultation Hours",
    ct_em: "For trauma emergencies, call {phone} — any hour.",
    ct_strip_label: "Skip the Queue",
    ct_strip_title: "Book your appointment online in under a minute.",
    ct_strip_btn: "Book Now",
    ct_map_label: "Find Us on the Map", ct_directions: "Get Directions",
    ct_linkedin: "Dr. Lokesh Naik G on LinkedIn",
    opd_mf: "Monday – Friday", opd_sat: "Saturday", opd_sun: "Sunday", opd_closed: "Closed",

    cd_hero_eyebrow: "Patient Guides",
    cd_hero_l1: "Understand your injury.", cd_hero_l2: "Own your recovery.",
    cd_hero_sub: "Plain-language guides to the conditions Dr. Naik treats — what they are, how they're diagnosed, and what treatment and recovery really look like.",

    gd_prefix: "Patient Guide", gd_of: "of",
    sec_overview: "Overview", sec_overview_q: "What is it?",
    sec_symptoms: "Symptoms", sec_symptoms_q: "What does it feel like?",
    sec_diagnosis: "Diagnosis", sec_diagnosis_q: "How is it diagnosed?",
    sec_treatment: "Treatment", sec_treatment_q: "How is it treated?",
    sec_recovery: "Recovery", sec_recovery_q: "What does recovery look like?",
    gd_urgent_title: "When to seek urgent care",
    gd_cta_eyebrow: "Talk to a Specialist",
    gd_cta_title: "Have these symptoms? Get a clear plan.",
    gd_cta_body: "Bring your X-rays and reports — a single consultation is often enough to chart the way forward.",
    gd_cta_book: "Book a Consultation", gd_next: "Next guide",
    gd_notfound: "Guide not found.", gd_back: "Back to all guides",
  },

  hi: {
    nav_home: "होम", nav_about: "परिचय", nav_treatments: "उपचार", nav_guides: "मार्गदर्शिका",
    nav_contact: "संपर्क", nav_book: "अपॉइंटमेंट बुक करें",
    brand_tag: "ऑर्थोपेडिक सिंपल व कॉम्प्लेक्स ट्रॉमा एवं पुनर्निर्माण",
    footer_blurb: "ऑर्थोपेडिक सिंपल व कॉम्प्लेक्स ट्रॉमा एवं पुनर्निर्माण सर्जरी विशेषज्ञ — मुंबई में सटीक, प्रमाण-आधारित फ्रैक्चर व जोड़ देखभाल से चाल बहाल करना और जीवन पुनः गढ़ना।",
    footer_explore: "देखें", footer_reach: "क्लीनिक से संपर्क करें",
    footer_rights: "© 2026 डॉ. लोकेश नाइक जी — ऑर्थोपेडिक ट्रॉमा केयर। सर्वाधिकार सुरक्षित।",
    footer_opd: "OPD: सोम–शुक्र सुबह 11 – शाम 7 · शनि सुबह 11 – दोपहर 3 · रविवार बंद",
    fl_home: "होम", fl_about: "डॉक्टर के बारे में", fl_treatments: "उपचार व विशेषज्ञता",
    fl_guides: "रोगी मार्गदर्शिका", fl_book: "अपॉइंटमेंट बुक करें", fl_contact: "संपर्क",

    hero_eyebrow: "ऑर्थोपेडिक सिंपल व कॉम्प्लेक्स ट्रॉमा सर्जरी · मुंबई",
    hero_line1: "ऑर्थोपेडिक ट्रॉमा व", hero_line2: "जोड़ प्रतिस्थापन सलाहकार",
    hero_motto: "\"जीवन ही चाल है और चाल ही जीवन है\"",
    hero_tagline: "चाल बहाल करना और जीवन पुनः गढ़ना…!",
    hero_sub: "{name} — {hospital} में {role}। जटिल फ्रैक्चर, पेल्विक व एसीटाबुलर ट्रॉमा में विशेषज्ञ — और आपको फिर से पैरों पर खड़ा करना।",
    hero_call: "कॉल करें {phone}",
    stat_exp_label: "सर्जिकल अनुभव",
    strip_from: "सर्जरी कक्ष से",
    strip_note: "डॉ. लोकेश नाइक जी द्वारा उपचारित वास्तविक केस — रोगी विवरण गोपनीय",

    phil_eyebrow: "हमारी कार्यप्रणाली",
    phil_title1: "ट्रॉमा अराजकता है।", phil_title2: "रिकवरी एक कारीगरी।",
    phil1_t: "अराजकता में सटीकता",
    phil1_b: "फ्रैक्चर सिर्फ टूटी हड्डी नहीं — वह थमी हुई ज़िंदगी है। हर सर्जरी की योजना शरीररचना को पूरी तरह बहाल करने की होती है, अंदाज़े से नहीं।",
    phil2_t: "राय से पहले प्रमाण",
    phil2_b: "AO INFINITY अध्ययन से लेकर अंतरराष्ट्रीय जर्नल के संपादकीय मंडल तक — हर उपचार अनुसंधान पर आधारित है, आदत पर नहीं।",
    phil3_t: "फिर से पैरों पर",
    phil3_b: "सर्जरी तो बस आधा रास्ता है। हर योजना में पुनर्वास सम्मिलित है — क्योंकि असली नतीजा आप हैं: चलते, काम करते, जीते हुए।",

    exp_eyebrow: "विशेषज्ञता के क्षेत्र",
    exp_title1: "जटिल ट्रॉमा,", exp_title2: "पूर्ण शांति से।",
    exp_view_all: "सभी उपचार देखें",

    about_eyebrow: "अपने सर्जन से मिलिए",
    about_para: "KIMS हुबली और डॉ. बालाभाई नानावटी अस्पताल में प्रशिक्षित, मुंबई व सियोल से ट्रॉमा और आर्थ्रोप्लास्टी फेलोशिप — डॉ. नाइक ने अपना करियर ऑर्थोपेडिक्स की सबसे कठिन चोटों को समर्पित किया है: जटिल फ्रैक्चर, पेल्विक ट्रॉमा, नॉनयूनियन और ट्रॉमा के बाद की विकृतियाँ।",
    about_badge1: "AO INFINITY अध्ययन सह-अन्वेषक",
    about_badge2: "जर्नल संपादक व समीक्षक",
    about_badge3: "ट्रॉमा व जोड़ प्रतिस्थापन",
    about_link: "पूरी कहानी पढ़ें",

    hosp_eyebrow: "हमें कहाँ मिलें",
    hosp_para: "भारत के सबसे उन्नत क्वाटरनरी केयर केंद्रों में से एक — समर्पित ट्रॉमा टीम, अत्याधुनिक ऑपरेशन थिएटर और चौबीसों घंटे आपातकालीन सुविधा। डॉ. नाइक यहाँ ट्रॉमा व जटिल फ्रैक्चर सेवाओं का नेतृत्व करते हैं।",
    hosp_cta: "विज़िट की योजना बनाएं",

    stories_eyebrow: "रोगियों के अनुभव",
    stories_verified: "{count} सत्यापित Google समीक्षाएँ",
    overlay_quote: "\"फिर से ज़िंदगी की ओर।\"", overlay_sub: "एकमात्र महत्वपूर्ण नतीजा",
    wall_title1: "हर रिकवरी की", wall_title2: "एक कहानी है।",
    wall_link: "Google पर सभी {count} समीक्षाएँ पढ़ें",
    google_tag: "Google",

    cta_eyebrow: "अपनी रिकवरी शुरू करें",
    cta_title1: "आपकी रिकवरी शुरू होती है", cta_title2: "एक बातचीत से।",

    mq1: "सटीकता", mq2: "पुनर्स्थापना", mq3: "गतिशीलता", mq4: "विश्वास",
    mq5: "प्रमाण-आधारित देखभाल", mq6: "रिकवरी",

    ab_hero_eyebrow: "डॉक्टर के बारे में",
    ab_hero_l1: "सबसे कठिन फ्रैक्चर पर", ab_hero_l2: "बना करियर।",
    ab_hero_sub: "दावणगेरे की कक्षाओं से मुंबई के ऑपरेशन थिएटर और सियोल के फेलोशिप हॉल तक — एक ही वादे को समर्पित उत्कृष्टता की यात्रा: चाल बहाल करना, और उसके साथ जीवन भी।",
    ab_qual_eyebrow: "योग्यताएँ",
    ab_qual_title1: "प्रशिक्षण:", ab_qual_title2: "भारत व दक्षिण कोरिया।",
    ab_bio1: "लोकेश नाइक जी ने अपनी चिकित्सा शिक्षा JJMMC दावणगेरे से शुरू की, जहाँ मानव शरीर की कार्यप्रणाली का जुनून पनपा। KIMS हुबली से सर्जिकल नींव मजबूत की और प्रसिद्ध डॉ. बालाभाई नानावटी अस्पताल, मुंबई से ऑर्थोपेडिक सर्जरी में D.N.B. हासिल की — देश के सबसे कठिन प्रशिक्षण केंद्रों में से एक।",
    ab_bio2: "जिन चोटों को छूने से दूसरे सर्जन हिचकते हैं, उन्हें सीखने के लिए उन्होंने मुंबई में ट्रॉमा व आर्थ्रोप्लास्टी की उन्नत फेलोशिप की, फिर जोड़ प्रतिस्थापन की विश्व-राजधानी सियोल, दक्षिण कोरिया गए — रिवीज़न आर्थ्रोप्लास्टी फेलोशिप के लिए: असफल सर्जरी को दूसरा जीवन देने की सूक्ष्म विद्या।",
    ab_bio3: "आज हर परामर्श उस यात्रा का सार लिए है — विश्व-स्तरीय प्रशिक्षण, ऐसे स्नेह के साथ जो सबसे घबराए रोगी को भी सहज कर दे। ऑपरेशन थिएटर के बाहर भी वे राष्ट्रीय व अंतरराष्ट्रीय जर्नल में शोध प्रकाशित कर चुके हैं और पुस्तक अध्याय लिखे हैं।",
    ab_journey_eyebrow: "यात्रा", ab_journey_title: "उत्कृष्टता की एक यात्रा।",
    ab_research_eyebrow: "शोध व शिक्षा",
    ab_research_title1: "सर्जन जो", ab_research_title2: "विज्ञान भी लिखता है।",
    ab_infinity_label: "ऐतिहासिक शोध",
    ab_infinity_title: "'INFINITY' अध्ययन — AO फाउंडेशन, दावोस",
    ab_infinity_body: "डॉ. नाइक फ्रैक्चर फिक्सेशन में संक्रमण पर विश्व के सबसे बड़े बहु-केंद्रीय अध्ययन (2013–2015) के सह-अन्वेषक रहे — ऐसा शोध जो दुनिया भर के सर्जन इस गंभीर जटिलता को रोकते और उपचारते हैं, उसे आकार देता है।",
    ab_editorial_label: "संपादकीय व समीक्षा भूमिकाएँ",
    ab_cta_title1: "अनुभव जो हर", ab_cta_title2: "नतीजे में झलके।",

    tl1_p: "शुरुआत", tl2_p: "5 वर्ष", tl3_p: "रेजिडेंसी", tl4_p: "2 वर्ष",
    tl5_p: "2013 — 2015", tl6_p: "फेलोशिप", tl7_p: "2016 – वर्तमान",
    tl1_r: "M.B.B.S., फिर ऑर्थोपेडिक्स में डिप्लोमा",
    tl2_r: "ऑर्थोपेडिक सर्जरी में लेक्चरर / सलाहकार",
    tl3_r: "D.N.B. (ऑर्थोपेडिक सर्जरी)",
    tl4_r: "क्लिनिकल एसोसिएट, ऑर्थोपेडिक्स",
    tl5_r: "सह-अन्वेषक, 'INFINITY' अध्ययन",
    tl6_r: "ट्रॉमा व प्राइमरी आर्थ्रोप्लास्टी (मुंबई), रिवीज़न आर्थ्रोप्लास्टी (सियोल)",
    tl7_r: "वरिष्ठ ऑर्थोपेडिक ट्रॉमा, पुनर्निर्माण व जोड़ प्रतिस्थापन सलाहकार",

    tr_hero_eyebrow: "उपचार व विशेषज्ञता",
    tr_hero_l1: "आठ क्षेत्र।", tr_hero_l2: "एक ही मापदंड: सटीकता।",
    tr_hero_sub: "ऑर्थोपेडिक ट्रॉमा क्षमा नहीं करता — पहला उपचार अक्सर रोगी के बाकी जीवन को तय करता है। ये वे स्थितियाँ हैं जिनका डॉ. नाइक सर एच. एन. रिलायंस फाउंडेशन अस्पताल, मुंबई में रोज़ इलाज करते हैं।",
    tr_guide_link: "रोगी मार्गदर्शिका पढ़ें",
    tr_proc_eyebrow: "की जाने वाली सर्जरी",
    tr_proc_title1: "सर्जिकल कौशल,", tr_proc_title2: "शुरू से अंत तक।",
    tr_proc_quote: "\"पुनर्स्थापना विज्ञान से की जाने वाली कला है।\"",
    tr_cta_title1: "समझ नहीं आ रहा कौन सा उपचार", tr_cta_title2: "आपकी स्थिति के लिए सही है?",
    tr_cta_sub: "अपनी रिपोर्ट और एक्स-रे साथ लाएँ। अक्सर एक ही परामर्श आगे का रास्ता तय करने के लिए काफी है।",
    tr_cta_btn: "परामर्श बुक करें",

    pr1: "ओपन रिडक्शन व इंटरनल फिक्सेशन (ORIF)",
    pr2: "टोटल हिप रिप्लेसमेंट",
    pr3: "टोटल नी रिप्लेसमेंट",
    pr4: "रिवीज़न व रीडू ऑर्थोपेडिक सर्जरी",
    pr5: "अंग लंबाई वृद्धि व विकृति सुधार",
    pr6: "एंकल फ्यूज़न सर्जरी",
    pr7: "टेढ़े पैर (बो लेग्स) का सुधार",
    pr8: "फ्रैक्चर फिक्सेशन — साधारण से जटिल",

    bk_hero_eyebrow: "अपॉइंटमेंट बुक करें",
    bk_hero_l1: "आइए आपकी रिकवरी", bk_hero_l2: "साथ मिलकर बनाएं।",
    bk_hero_sub: "कुछ जानकारी साझा करें — क्लीनिक {name} के साथ आपके परामर्श की पुष्टि करेगा। जरूरी ट्रॉमा के लिए सीधे कॉल करें।",
    bk_info_eyebrow: "बात करना चाहेंगे?",
    bk_call_label: "कॉल / WhatsApp", bk_email_label: "ईमेल", bk_clinic_label: "क्लीनिक",
    bk_opd_label: "OPD समय", bk_opd1: "सोम – शुक्र: सुबह 11 – शाम 7", bk_opd2: "शनि: सुबह 11 – दोपहर 3 · रवि: बंद",
    bk_em_label: "ट्रॉमा आपातकाल?",
    bk_em_body: "ऑनलाइन पुष्टि की प्रतीक्षा न करें। तुरंत {phone} पर कॉल करें या आपातकालीन विभाग जाएँ।",
    f_name: "पूरा नाम *", f_age: "उम्र *", f_sex: "लिंग *", f_phone: "फोन *", f_email: "ईमेल *",
    f_date: "पसंदीदा तारीख *", f_time: "पसंदीदा समय *", f_concern: "समस्या *", f_message: "और बताएँ (वैकल्पिक)",
    f_name_ph: "आपका पूरा नाम", f_age_ph: "वर्ष", f_phone_ph: "+91 ...", f_email_ph: "you@example.com",
    f_time_ph: "समय चुनें", f_concern_ph: "किस समस्या के लिए आए हैं?", f_sex_ph: "चुनें",
    f_message_ph: "अपनी चोट या समस्या संक्षेप में बताएँ, और कोई रिपोर्ट या एक्स-रे हो तो उल्लेख करें।",
    f_submit: "अपॉइंटमेंट का अनुरोध करें", f_submitting: "भेजा जा रहा है…",
    f_note: "आपका अनुरोध सीधे डॉक्टर के कार्यालय को {email} पर ईमेल होता है। ऑनलाइन कोई भुगतान नहीं लिया जाता।",
    f_validation: "कृपया रोगी का लिंग, समस्या और पसंदीदा समय चुनें।",
    sex_m: "पुरुष", sex_f: "महिला", sex_o: "अन्य",
    c1: "फ्रैक्चर / ट्रॉमा", c2: "जोड़ प्रतिस्थापन", c3: "नॉनयूनियन / मालयूनियन",
    c4: "हड्डी या जोड़ का संक्रमण", c5: "विकृति सुधार", c6: "दूसरी राय", c7: "अन्य",
    ts1: "सुबह (10 – दोपहर 1)", ts2: "दोपहर (2 – शाम 5)", ts3: "शाम (5 – रात 8)",
    ok_title: "अनुरोध मिल गया।",
    ok_body: "धन्यवाद, {name}। {date} ({slot}) के लिए आपका अपॉइंटमेंट अनुरोध क्लीनिक को भेज दिया गया है। पुष्टि के लिए क्लीनिक आपको {phone} पर कॉल करेगा।",
    ok_ref: "संदर्भ:", ok_another: "एक और अपॉइंटमेंट बुक करें",
    ok_email_note: " और डॉक्टर के कार्यालय को ईमेल भी हो गया है।",
    toast_success: "अपॉइंटमेंट अनुरोध भेजा गया। क्लीनिक शीघ्र पुष्टि करेगा।",
    toast_error: "अभी सबमिट नहीं हो सका — कृपया क्लीनिक को सीधे कॉल करें।",

    ct_hero_eyebrow: "संपर्क",
    ct_hero_l1: "एक कॉल बदल सकती है", ct_hero_l2: "आपकी चलने की राह।",
    ct_hero_sub: "नई चोट हो, न बरने वाला फ्रैक्चर, या दूसरी राय — संपर्क करें। हर जिज्ञासा का उत्तर क्लीनिक स्वयं देता है।",
    ct_call_label: "कॉल या WhatsApp",
    ct_call_body: "क्लीनिक तक पहुँचने का सबसे तेज़ तरीका — अपॉइंटमेंट और जरूरी ट्रॉमा पूछताछ के लिए।",
    ct_call_now: "अभी कॉल करें",
    ct_email_label: "हमें लिखें",
    ct_email_body: "रिपोर्ट, एक्स-रे या प्रश्न साझा करें। ऑनलाइन भेजे बुकिंग अनुरोध भी यहीं आते हैं।",
    ct_email_cta: "ईमेल भेजें",
    ct_visit_label: "क्लीनिक पर आएँ", ct_hours_label: "परामर्श समय",
    ct_em: "ट्रॉमा आपातकाल में {phone} पर कॉल करें — किसी भी समय।",
    ct_strip_label: "कतार से बचें",
    ct_strip_title: "एक मिनट से भी कम में ऑनलाइन अपॉइंटमेंट बुक करें।",
    ct_strip_btn: "अभी बुक करें",
    ct_map_label: "नक्शे पर हमें खोजें", ct_directions: "रास्ता देखें",
    ct_linkedin: "LinkedIn पर डॉ. लोकेश नाइक जी",
    opd_mf: "सोमवार – शुक्रवार", opd_sat: "शनिवार", opd_sun: "रविवार", opd_closed: "बंद",

    cd_hero_eyebrow: "रोगी मार्गदर्शिका",
    cd_hero_l1: "अपनी चोट को समझें।", cd_hero_l2: "रिकवरी को अपनाएं।",
    cd_hero_sub: "डॉ. नाइक जिन स्थितियों का इलाज करते हैं, उनकी सरल-भाषा मार्गदर्शिकाएँ — वे क्या हैं, निदान कैसे होता है, और उपचार व रिकवरी वास्तव में कैसी होती है।",

    gd_prefix: "रोगी मार्गदर्शिका", gd_of: "में से",
    sec_overview: "परिचय", sec_overview_q: "यह क्या है?",
    sec_symptoms: "लक्षण", sec_symptoms_q: "कैसा महसूस होता है?",
    sec_diagnosis: "निदान", sec_diagnosis_q: "जाँच कैसे होती है?",
    sec_treatment: "उपचार", sec_treatment_q: "इलाज कैसे होता है?",
    sec_recovery: "रिकवरी", sec_recovery_q: "रिकवरी कैसी होती है?",
    gd_urgent_title: "तुरंत देखभाल कब लें",
    gd_cta_eyebrow: "विशेषज्ञ से बात करें",
    gd_cta_title: "ये लक्षण हैं? स्पष्ट योजना पाएँ।",
    gd_cta_body: "अपने एक्स-रे और रिपोर्ट साथ लाएँ — अक्सर एक ही परामर्श आगे का रास्ता तय करने के लिए काफी है।",
    gd_cta_book: "परामर्श बुक करें", gd_next: "अगली मार्गदर्शिका",
    gd_notfound: "मार्गदर्शिका नहीं मिली।", gd_back: "सभी मार्गदर्शिकाओं पर वापस",
  },
};
